module.exports = __webpack_public_path__ + "static/media/Imagen_2.67d92023.png";